import React, { ReactElement, useState } from 'react'
import { DatePicker, HeaderPage, Input, Select } from '@components/atoms'
import { ContainerPesquisa } from '@pages/style'
import { useForm } from 'react-hook-form'
import { Button, Col, Row, Typography, Table, Spin, Drawer } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { SearchOutlined } from '@ant-design/icons'

const data = [
  {
    DESCPRODUTO: 'a',
  },
]
const data2 = [
  {
    DESCPRODUTO: 'b',
  },
]
const data3 = [
  {
    DESCPRODUTO: 'c',
  },
]

export default function ProdutoVendidoCliente(): ReactElement {
  const { control, watch, reset } = useForm()
  const { Option } = Select
  // const methods = useForm()
  const allFields = /* methods. */ watch()
  const { Column } = Table
  const [spinning, setSpinning] = useState(false)
  const [visible, setVisible] = useState(false)

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  const limparFiltros = () => {
    reset()
  }

  return (
    <ContainerPesquisa>
      <Content style={{ padding: 24 }}>
        <Spin tip='Filtrando...' spinning={spinning}>
          <HeaderPage
            title='Produto Vendido por Cliente'
            extra={[
              <Button
                key='buttonSearch'
                className='buttonSearch'
                onClick={() => showDrawer()}
              >
                <p>Filtrar</p>
                <SearchOutlined key='iconSearch' className='iconSearch' />
              </Button>,
            ]}
          />
          <Table dataSource={data}>
            <Column title='Cliente' dataIndex={'CLIENTE'} />
            <Column title='Total' dataIndex={'TOTAL'} />
          </Table>
          <Table dataSource={data2}>
            <Column title='Produtos' dataIndex={'PRODUTOS'} />
            <Column title='Quantidade' dataIndex={'QUANTIDADE'} />
            <Column title='Valor' dataIndex={'VALOR'} />
          </Table>
          <Table dataSource={data3}>
            <Column title='Venda' dataIndex={'VENDA'} />
            <Column title='Data Venda' dataIndex={'DTVENDA'} />
            <Column title='Quantidade' dataIndex={'QUANTIDADE'} />
            <Column title='Valor' dataIndex={'VALOR'} />
            <Column title='Vendedor' dataIndex={'VENDEDOR'} />
          </Table>
        </Spin>
      </Content>
      <Drawer
        onClose={onClose}
        visible={visible}
        title='Filtros'
        style={{ marginTop: '4rem' }}
      >
        <Row key='mainRow'>
          <Col span={allFields.CLIENTE === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Cliente</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='CLIENTE'
              placeholder='Cliente'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.CLIENTE === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Cliente Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='CLIENTEESPEC'
                placeholder='Cliente Específico'
              >
                <Option value='Cliente 1'>Cliente 1</Option>
                <Option value='Cliente 2'>Cliente 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.PRODUTO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Produto</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='PRODUTO'
              placeholder='Produto'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.PRODUTO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Produto Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='PRODUTOESPEC'
                placeholder='Produto Específico'
              >
                <Option value='Produto 1'>Produto 1</Option>
                <Option value='Produto 2'>Produto 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.VENDEDOR === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Vendedor</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='VENDEDOR'
              placeholder='Vendedor'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.VENDEDOR === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Vendedor Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='VENDEDORESPEC'
                placeholder='Vendedor Específico'
              >
                <Option value='Vendedor 1'>Vendedor 1</Option>
                <Option value='Vendedor 2'>Vendedor 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.GRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Grupo</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='GRUPO'
              placeholder='Grupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.GRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Grupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='GRUPOESPEC'
                placeholder='Grupo Específico'
              >
                <Option value='Grupo 1'>Grupo 1</Option>
                <Option value='Grupo 2'>Grupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.SUBGRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>SubGrupo</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='SUBGRUPO'
              placeholder='SubGrupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.SUBGRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>SubGrupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='SUBGRUPOESPEC'
                placeholder='SubGrupo Específico'
              >
                <Option value='SubGrupo 1'>SubGrupo 1</Option>
                <Option value='SubGrupo 2'>SubGrupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={24}>
            <Typography.Title level={5}>Período</Typography.Title>
            <Row gutter={3} align='middle'>
              <Col span={12}>
                <DatePicker name='DTINICIO' control={control} />
              </Col>
              <Col span={12}>
                <DatePicker name='DTFINAL' control={control} />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Typography.Title level={5}>Aplicação</Typography.Title>
            <Select
              control={control}
              allowClear
              name='APLICACAO'
              placeholder='Aplicação'
            >
              <Option value='Venda'>Venda</Option>
              <Option value='Retorno de Remessa'>Retorno de Remessa</Option>
              <Option value='Remessa de Mercadoria'>
                Remessa de Mercadoria
              </Option>
              <Option value='Bonificação'>Bonificação</Option>
              <Option value='Devolução de Venda'>Devolução de Venda</Option>
              <Option value='Devolução de Compra'>Devolução de Compra</Option>
              <Option value='Entrada'>Entrada</Option>
              <Option value='Transf. de Mercadoria'>
                Transf. de Mercadoria
              </Option>
              <Option value='Consignação'>Consignação</Option>
              <Option value='Serviço'>Serviço</Option>
            </Select>
          </Col>
          <Col span={24} style={{ marginTop: '1.5rem' }}>
            <Row gutter={5}>
              <Col>
                <Button
                  danger
                  type='default'
                  onClick={() => {
                    limparFiltros()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Limpar filtro
                </Button>
              </Col>
              <Col>
                <Button
                  type='primary'
                  onClick={() => {
                    onClose()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Filtrar
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
    </ContainerPesquisa>
  )
}
